import { CORE_TOOLBAR_IDS } from "contexts/toolbars";

import { Toolbar } from "../Toolbar";
import { ToolbarColumn } from "../ToolbarColumn";

interface DetailsToolbarProps {
    id?: string;
    /** Extra toolbars stacked below, sharing the column's tooltip coordination. */
    children?: React.ReactNode;
}

/**
 * Presentational toolbar for model details. Registration and sync are handled by
 * useDetailsToolbarRegistration (called from DetailsMenu).
 */
export function DetailsToolbar({ id = CORE_TOOLBAR_IDS.DETAILS, children }: DetailsToolbarProps) {
    return (
        <ToolbarColumn>
            <Toolbar id={id} />
            {children}
        </ToolbarColumn>
    );
}
